const placeFallback = `${process.env.PUBLIC_URL}/images/category/kategoria-zabytki.jpeg`;
const eventFallback = `${process.env.PUBLIC_URL}/images/category/kategoria-eventy.jpg`;

export function getFallbackImage(type) {
  return type === "event" ? eventFallback : placeFallback;
}

export function getImageSource(item, type) {
  return item?.images?.[0]?.img || getFallbackImage(type);
}

export function replaceWithFallback(event, type) {
  const fallback = getFallbackImage(type);

  event.currentTarget.onerror = null;
  event.currentTarget.src = fallback;
}